import { App, Modal, message } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';
import type { ModalStaticFunctions } from 'antd/es/modal/confirm';
import React from 'react';

let messageInstance: MessageInstance | null = null;
let modalInstance: Omit<ModalStaticFunctions, 'warn'> | null = null;

const getMessageApi = () => messageInstance ?? message;
const getModalApi = () => modalInstance ?? Modal;

export const setAppMessageInstance = (instance: MessageInstance | null) => {
  messageInstance = instance;
};

export const setAppModalInstance = (
  instance: Omit<ModalStaticFunctions, 'warn'> | null,
) => {
  modalInstance = instance;
};

export const appMessage = {
  success: (content: React.ReactNode) => getMessageApi().success(content),
  error: (content: React.ReactNode) => getMessageApi().error(content),
  warning: (content: React.ReactNode) => getMessageApi().warning(content),
  info: (content: React.ReactNode) => getMessageApi().info(content),
  loading: (content: React.ReactNode) => getMessageApi().loading(content),
};

export const appModal = {
  confirm: (props: Parameters<ModalStaticFunctions['confirm']>[0]) =>
    getModalApi().confirm(props),
  info: (props: Parameters<ModalStaticFunctions['info']>[0]) =>
    getModalApi().info(props),
  success: (props: Parameters<ModalStaticFunctions['success']>[0]) =>
    getModalApi().success(props),
  error: (props: Parameters<ModalStaticFunctions['error']>[0]) =>
    getModalApi().error(props),
  warning: (props: Parameters<ModalStaticFunctions['warning']>[0]) =>
    getModalApi().warning(props),
};

export const AppMessageBridge: React.FC = () => {
  const { message: antMessage, modal: antModal } = App.useApp();

  React.useEffect(() => {
    setAppMessageInstance(antMessage);
    setAppModalInstance(antModal);
    return () => {
      setAppMessageInstance(null);
      setAppModalInstance(null);
    };
  }, [antMessage, antModal]);

  return null;
};
